<template>
  <ul class="space-y-2">
    <custom-webhook-parameter-list-item
      v-for="parameter in parameters"
      :key="parameter.name"
      :parameter="parameter"
      @parameter:change="emit('parameter:change', $event)"
    />
  </ul>
</template>
<script setup lang="ts">
import CustomWebhookParameterListItem from "@/components/communication/CustomWebhookParameterListItem.vue";

import type { OptionalWorkflowWebhookParameter } from "@/models/workflows";

const { parameters } = defineProps<{
  parameters: OptionalWorkflowWebhookParameter[];
}>();

const emit = defineEmits<{
  "parameter:change": [OptionalWorkflowWebhookParameter];
}>();
</script>
